'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/core/styles');
var useMediaQuery = require('@material-ui/core/useMediaQuery');
var DeviceContext = require('./DeviceContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useMediaQuery__default = /*#__PURE__*/_interopDefaultLegacy(useMediaQuery);

/**
 * Given the current size of the screen and the isMobile flag, determines which
 * rendering mode should be selected.
 */

function getMode(_ref) {
  var {
    width,
    isMobile
  } = _ref;
  return isMobile && ['xs', 'sm'].includes(width) ? 'mobile' : 'desktop';
}

var DeviceProvider = _ref2 => {
  var {
    children
  } = _ref2;
  var theme = styles.useTheme();
  var keys = [...theme.breakpoints.keys].reverse(); // Note: this check will break if there is any customization of the break-
  // points in the theme configuration.

  var width = keys.reduce((output, key) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var matches = useMediaQuery__default['default'](theme.breakpoints.up(key));
    return !output && matches ? key : output;
  }, null) || 'xs';
  var isPortrait = useMediaQuery__default['default']('(orientation: portrait)');
  var isLandscape = useMediaQuery__default['default']('(orientation: landscape)');
  var orientation = isPortrait ? 'portrait' : isLandscape ? 'landscape' : 'unknown'; // From:
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#Mobile_Device_Detection

  var [isMobile, setIsMobile] = React__default['default'].useState(false);
  React__default['default'].useEffect(() => {
    if (window.navigator) {
      var _window$navigator$use, _window$navigator;

      setIsMobile((_window$navigator$use = !!((_window$navigator = window.navigator) !== null && _window$navigator !== void 0 && _window$navigator.userAgent.match(/Mobi/i))) !== null && _window$navigator$use !== void 0 ? _window$navigator$use : false);
    }
  }, []);
  var mode = getMode({
    width,
    isMobile
  });
  return /*#__PURE__*/React__default['default'].createElement(DeviceContext.DeviceContext.Provider, {
    value: {
      width,
      isMobile,
      orientation,
      mode
    }
  }, children);
};
DeviceProvider.propTypes = {
  children: index.node
};

exports.DeviceProvider = DeviceProvider;
